import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TableColumnComponent } from "src/app/components/ui/table/table-column/table-column.component";
import { TableComponent } from "src/app/components/ui/table/table.component";
import { CdkTableModule } from "@angular/cdk/table";
import { DirectivesModule } from "src/app/modules/bootstrap/directives/directives.module";

@NgModule({
  imports: [CommonModule, CdkTableModule, DirectivesModule],
  declarations: [TableComponent, TableColumnComponent],
  exports: [TableComponent, TableColumnComponent]
})
export class TableModule {}
